import { AccountVestingTypeEnum } from 'constants/vesting'
import { AccountVestingProviderV2 } from 'context/account-vesting-context-provider-v2'
import AccountVestingContentV2 from 'modules/account-vesting-v2/account-vesting-content-v2'

import './style.scss'

const AccountVestingHMCV2 = () => {
  return (
    <AccountVestingProviderV2 type={AccountVestingTypeEnum.ACCOUNT_VESTING_HMC_V2}>
      <AccountVestingContentV2 title="Account Vesting HMC V2" />
    </AccountVestingProviderV2>
  )
}

export default AccountVestingHMCV2
